// API END Points
import * as constants from "../utils/constants";
/**---------------Authentication------------------------------ */
export const LOGIN = "_admin/login" + " " + constants.POST_RAW;
export const LOGOUT = "_admin/logout" + " " + constants.POST_RAW;
export const AUTH = {
  FORGET_PASSWORD: "_admin/password/forgot" + " " + constants.POST_RAW,
};
export const FORGET_PASSWORD =
  "_admin/password/forgot" + " " + constants.POST_RAW;
export const ADD_AGE_GROUP = "_admin/age-group" + " " + constants.POST_RAW;
export const AGE_GROUP_LIST =
  "_admin/age-group" + " " + constants.GET_URL_PARAMS;
export const DELETE_AGE_GROUP =
  "_admin/age-group" + " " + constants.DELETE_ID_PARAMS;
export const DEFAULT_ACTIVITIES = "_admin/default" + " " + constants.GET;
export const EDIT_AGE_GROUP = "_admin/age-group" + " " + constants.PATCH_ID;
export const AGE_GROUP_DETAILS =
  "_admin/age-group" + " " + constants.GET_ID_PARAMS;
export const MASTER = {
  ADD_CLASS_SUBJECT: "_admin/class" + " " + constants.POST_RAW,
  CLASS_SUBJECT_DETAILS: "_admin/class" + " " + constants.GET_ID_PARAMS,
  EDIT_CLASS_SUBJECT: "_admin/class" + " " + constants.PATCH_ID,
  DELETE_CLASS_SUBJECT: "_admin/class" + " " + constants.DELETE_ID_PARAMS,
  CLASS_SUBJECT_LIST: "_admin/class" + " " + constants.GET_URL_PARAMS,
};
export const ADD_VENDOR_CATEGORY = "_admin/category" + " " + constants.POST_RAW;
export const VENDOR_CATEGORY_LIST =
  "_admin/category" + " " + constants.GET_URL_PARAMS;
export const DELETE_VENDOR_CATEGORY =
  "_admin/category" + " " + constants.DELETE_ID_PARAMS;
export const EDIT_VENDOR_CATEGORY =
  "_admin/category" + " " + constants.PATCH_ID;
export const VENDOR_CATEGORY_DETAILS =
  "_admin/category" + " " + constants.GET_ID_PARAMS;
export const activityConfig = {
  GET_ACTIVITIES_LIST: "_admin/age-group" + " " + constants.GET_URL_PARAMS,
  GET_DEFAULT_ACTIVITIES: "_admin/default" + " " + constants.GET,
  GET_AGE_GROUP_DETAIL: "_admin/age-group" + " " + constants.GET_ID_PARAMS,
  GET_AGE_GROUP_LIST: "_admin/age-group" + " " + constants.GET_URL_PARAMS,
  EDIT_ACTIVITIES: "_admin/age-group" + " " + constants.PATCH_ID,
  DELETE_ACTIVITY: "_admin/age-group/activities" + " " + constants.PATCH_ID,
  ACTIVATE_ACTIVITY: "_admin/age-group/deactivate" + " " + constants.PATCH_ID,
};
export const SCHOOL = {
  ADD_SCHOOL_DETAILS: "_school/manage-schools/add" + " " + constants.POST_FORM,
  ADD_REPEATED_SCHOOL_DETAILS:
    "_school/manage-schools/addExistingSchoolAdmin" + " " + constants.POST_FORM,
  GET_SCHOOL_DETAILS: "_school/manage-schools" + " " + constants.GET_ID_PARAMS,
  GET_SCHOOL_LIST:
    "_school/manage-schools/list" + " " + constants.GET_URL_PARAMS,
  GET_SCHOOL_INFO:
    "_school/manage-schools/info" + " " + constants.GET_ID_PARAMS,
  EDIT_SCHOOL_INFO: "_school/manage-schools/edit" + " " + constants.PATCH_ID,
  DELETE_SCHOOL:
    "_school/manage-schools/profile" + " " + constants.DELETE_ID_PARAMS,
  GET_ACDEMICYEAR_LIST:
    "_school/manage-schools/academic" + " " + constants.GET_URL_PARAMS,
  UPDATE_ACADEMIC_YEAR:
    "_school/manage-schools/activate-academic" + " " + constants.PATCH_ID,
};
export const TEACHER = {
  GET_TEACHER_LIST: "_admin/teacher/list" + " " + constants.GET_URL_PARAMS,
  GET_TEACHER_INFO: "_admin/teacher/info" + " " + constants.GET_ID_PARAMS,
};
export const STUDENT = {
  GET_STUDENT_LIST: "_admin/students/list" + " " + constants.GET_URL_PARAMS,
  GET_STUDENT_INFO: "_admin/students/info" + " " + constants.GET_ID_PARAMS,
};
export const CSM_PAGE = {
  GET_PRIVACY_POLICY:
    "_default/privacy-policy" + " " + constants.GET_URL_PARAMS,
  GET_TERMS_CONDITIONS:
    "_default/terms-conditions" + " " + constants.GET_URL_PARAMS,
  GET_ABOUT_US: "_default/about-us" + " " + constants.GET_URL_PARAMS,
  POST_ABOUT_US: "_default/about-us" + " " + constants.POST_RAW,
  POST_PRIVACY_POLICY: "_default/privacy-policy" + " " + constants.POST_RAW,
  POST_TERMS_CONDITIONS: "_default/terms-conditions" + " " + constants.POST_RAW,
};
export const VENDORS = {
  GET_VENDOR_LIST: "_vendor/vendors" + " " + constants.GET_URL_PARAMS,
  GET_CATEGORY_LIST:
    "_vendor/vendors/category" + " " + constants.GET_URL_PARAMS,
  updateStatus:
    "_vendor/vendors/activate-deactivate" + " " + constants.PATCH_ID,
  updateApproval: "_vendor/vendors/approval" + " " + constants.PATCH_ID,
  categotyList: "_vendor/vendors/category" + " " + constants.GET_URL_PARAMS,
  createVendor: "_vendor/vendors" + " " + constants.POST_FORM,
  getVendorDetails: "_vendor/vendors/info" + " " + constants.GET_ID_PARAMS,
  updateVendor: "_vendor/vendors/edit" + " " + constants.PATCH_ID,
  DELETE_VENDOR: "_vendor/vendors" + " " + constants.DELETE_ID_PARAMS,
  getAllServices:
    "_vendor/vendors/all-services/info" + " " + constants.GET_URL_ID_PARAMS,
  updateServiceStatus:
    "_vendor/vendors/service-approval" + " " + constants.PATCH_ID,
};
export const settings = {
  addAppSettings:
    "_admin/config/app-settings" + " " + constants.PATCH_URL_ENCODED,
  getAppSettings: "_admin/config/app-settings" + " " + constants.GET_URL_PARAMS,
};
export const dashBoardEndPoints = {
  STATUS_COUNT: "_admin/dashboard/stats" + " " + constants.GET_URL_PARAMS,
  SCHOOL_STUDENT:
    "_admin/dashboard/school-wise-student" + " " + constants.GET_URL_PARAMS,
  CLASS_STUDENT:
    "_admin/dashboard/class-wise-student" + " " + constants.GET_URL_PARAMS,
  VENDORS_COUNT:
    "_admin/dashboard/registered-vendors" + " " + constants.GET_URL_PARAMS,
  REGISTERED_SCHOOL:
    "_admin/dashboard/registered-school" + " " + constants.GET_URL_PARAMS,
  GET_RECENTLY_VENDORSLIST:
    "_admin/dashboard/recent-registered-vendors" +
    " " +
    constants.GET_URL_PARAMS,
};
export const academic = {
  GET_ACADEMIC_LIST: "_admin/academic-year" + " " + constants.GET_URL_PARAMS,
  DELETE_ACADEMY_YEAR:
    "_admin/academic-year/delete" + " " + constants.DELETE_ID_PARAMS,
  ACTIVATE_ACADEMY: "_admin/academic-year/isActive" + " " + constants.PATCH_ID,
  ADD_ACADEMY_YEAR: "_admin/academic-year" + " " + constants.POST_FORM,
};
